import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { MailchimpService }           from './mailchimp.service';
import { MailchimpSettingsComponent } from './mailchimp.settings.component';
import { MailchimpStates }            from './mailchimp.states';
import { MessagesModule }             from '../messages/messages.module';
import { SharedModule }               from '../shared/shared.module';

@NgModule({
  declarations: [
    MailchimpSettingsComponent
  ],
  entryComponents: [
    MailchimpSettingsComponent
  ],
  imports: [
    MessagesModule,
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: MailchimpStates })
  ],
  providers: [
    MailchimpService
  ]
})
export class MailchimpModule {}
